/**
 * Created by intellicar-rinas on 4/6/18.
 */
import React, {Component} from 'react';
import './InVoice.css';
import getGreetingMessage from './lib/greetingMessage';
import getFailureMessage from './lib/failureMessage';
import getStartActionMessage from './lib/startActionMessage';

export default class InVoice extends Component{

    state = {};

    constructor() {
        super();

        if (!('webkitSpeechRecognition' in window)) {
            console.log('webkitSpeechRecognition not found');
        } else {
            console.log('%cSpeech Recognition Enabled', 'color:green');
            this.recognition = new window.webkitSpeechRecognition();
            this.recognition.continuous = true;
            this.recognition.interimResults = true;

            this.recognition.onstart = ()=> {
                this.startedAt = Date.now();
            };

            this.recognition.onresult = (event)=> {
                let results = [];
                for(let idx in event.results) {
                    // if(event.results[idx].isFinal || (event.results[idx][0] && event.results[idx][0].confidence > .7)) {
                    if(event.results[idx].isFinal) {
                        results.push(event.results[idx][0]);
                    }
                }
                this.onResult(results);
            };

            this.recognition.onerror = function (event) {};

            this.recognition.onend = ()=> {
                this.recognition.start();
            };

            this.recognition.start();

            // setTimeout(()=>{
            //    this.onResult([{transcript: 'hello'}]);
            //    setTimeout(()=>{
            //        // this.onResult([{transcript: 'search eco and goto history'}]);
            //        // this.onResult([{transcript: 'show driving report'}]);
            //        // setTimeout(()=>{
            //        //     this.onResult([{transcript: 'show driving report'}]);
            //        // }, 2000);
            //    }, 1000)
            // }, 1500);


        }
    }

    componentDidMount () {

        this.name = this.props.name || 'hello';


    }

    newSpeech =(str, callback=()=>{})=> {

        let msg = new window.SpeechSynthesisUtterance();
        // let voices = window.speechSynthesis.getVoices();
        // msg.voice = voices[9]; // Note: some voices don't support altering params
        msg.voiceURI = 'native';
        msg.volume = 1; // 0 to 1
        msg.rate = 1; // 0.1 to 10
        msg.pitch = 1; //0 to 2
        msg.text = str;
        msg.lang = 'en-US';

        msg.onend = function(e) {
            callback(e);
        };

        speechSynthesis.speak(msg);
    };

    onResult =results=> {
        if(results.length) {
            if(this.state.active) {
                this.processCommand(results);
            } else {
                this.activateSpeech(results);
            }
        }
    };

    activateSpeech =results=> {
        if((results[0].transcript).indexOf(this.name) !== -1) {
            this.activatedAt = Date.now();
            this.setActive(true);
        }
    };

    heartBeat() {
        clearTimeout(this.heartBeatTimeout);
        this.updatedAt = Date.now();
        this.heartBeatTimeout = setTimeout(()=>{
            this.setActive(false);
        }, 8000);
    }

    setActive =status=> {
        this.setState({active: status});
        if(status) {
            this.newSpeech(getGreetingMessage());
        }
        this.heartBeat();
    };



    runCommand =str=> {
        let valid;
        for(let idx in this.props.commands) {
            for(let kdx in this.props.commands[idx].cmds) {
                let cmdArr = this.props.commands[idx].cmds[kdx].split('*').filter(c=>c!=null && c.trim() != '').map(c=>c.trim());
                valid = true;
                for(let jdx in cmdArr) {
                    if(str.indexOf(cmdArr[jdx]) === -1) {
                        valid = false;
                    }
                }
                if(valid) {
                    let parameters = [];
                    for(let jdx=0; jdx<cmdArr.length; jdx++) {
                        let leftStr = cmdArr[jdx] || '';
                        let rightStr = cmdArr[jdx + 1];
                        let resultStr = str;

                        if(leftStr) {
                            resultStr = resultStr.split(leftStr)[1];
                        }

                        if(rightStr) {
                            resultStr = resultStr.split(rightStr)[0];
                        }

                        if(resultStr) {
                            parameters.push(resultStr.trim());
                        }
                    }
                    this.newSpeech(getStartActionMessage(this.props.commands[idx].cmds[kdx], parameters));
                    this.props.commands[idx].onTrigger(parameters, this.newSpeech, kdx);
                    return;
                }
            }
        }
        // this.newSpeech(getFailureMessage());
    };

    processCommand =results=> {
        // if(this.startedAt > this.activatedAt) {
        let cmd = results[results.length-1].transcript;
        if(this.props.onResult && this.lastCommand != cmd) {
            this.props.onResult(results);
            this.lastCommand = cmd;
            this.runCommand(results[results.length-1].transcript)
        }
        // }
    };

    render () {
        return (
            <div className={"InVoice" + (!this.state.active ? ' -disabled' : '')}>
                <div className="iv-container">
                    <div className="ivc-head">
                        <div className="ivch-circle c1"></div>
                        <div className="ivch-circle c2"></div>
                        <div className="ivch-circle c3"></div>
                    </div>
                </div>
            </div>
        )
    }

}